import { useRouter } from 'next/router'
import { useInfiniteQuery } from 'react-query'
import { isUndefined } from 'lodash-es'

// Libs
import { fetchLiveRoomListByProductId } from '@/api/fetchLiveRoomListByProductId'

// Constants
import { QUERY_KEY } from '@/constants/queryKey'

// Interfaces
interface IParams {
  productId: string
  liveTypes: string
}

export const useLiveRoomListByProductId = (params: IParams) => {
  const { productId } = params
  const router = useRouter()
  const defaultPageNo = 1
  const defaultPageSize = 4

  const liveRoomListDataInstance = useInfiniteQuery(
    [QUERY_KEY.FETCH_LIVE_ROOM_LIST_BY_PRODUCT_ID, { ...params }],
    ({ pageParam = defaultPageNo }) => {
      return fetchLiveRoomListByProductId({
        ...params,
        pageSize: defaultPageSize,
        pageNo: pageParam,
      })
    },
    {
      enabled: !isUndefined(productId),
      getNextPageParam: (lastPage, pages) => {
        if (!router.isReady) return undefined

        const currentPage = pages.length
        const totalPage = lastPage?.totalPage.totalPages
        let result: number | undefined = 0

        if (lastPage?.totalPage.totalPages === 0) {
          result = undefined
        } else {
          result = currentPage === totalPage ? undefined : currentPage + 1
        }

        return result
      },
    },
  )

  return {
    liveRoomListDataInstance,
  }
}
